import React, { useEffect, useState } from "react";
import { useAlert } from "../AlertContext";

const AlertDisplay = () => {
  const { alert } = useAlert();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (alert) {
      setVisible(true);
      const timeout = setTimeout(() => setVisible(false), 2500);
      return () => clearTimeout(timeout);
    }
  }, [alert]);

  if (!alert) return null;

  return (
    <div
      className={`alert alert-${alert.type} alert-dismissible fade ${
        visible ? "show" : ""
      }`}
      role="alert"
      style={{
        position: "fixed",
        top: "80px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1055,
        width: "90%",
        // maxWidth: "500px",
        transition: "opacity 0.5s ease-in-out",
        boxShadow: "0 0 10px rgba(0,0,0,0.2)",
        textAlign: "center",
      }}
    >
      {alert.message}
    </div>
  );
};

export default AlertDisplay;
